<template>
  <div class="serp__filter-filter--container q-py-1 q-shadow-sm q-my-2 q-mb-3 q-rounded-3 q-bg-white ">
    <div class="q-accordion-item">
      <h6
          class="q-accordion-header q-position-relative serp__filter-item--header q-accordion-button q-rotatable q-p-3 q-py-2 q-mt-0 q-fs-6 q-my-0 q-fw-semibold"
          :class="{'q-collapsed': isCollapsed, 'q-rotated': !isCollapsed}"
          @click="toggleAccordion"
          :aria-expanded="!isCollapsed.toString()"
          :aria-controls="filter.field"
      >
        {{ filter.label }}
      </h6>

      <div
          :id="filter.field"
          class="q-accordion-collapse"
          :class="{'q-collapse': isCollapsed, 'q-show': !isCollapsed}"
          :aria-labelledby="filter.field"
      >
        <div class="q-accordion-body q-p-1">
          <div class="serp__filter-item--container q-container-fluid" :class="computedClassContainer">
            <ul :class="computedClass" class="q-my-1">

              <li
                  class="q-input-group q-input-group-sm q-my-2 filter-search__container"
                  v-if="(filter.type !== 'range' && filter.type !== 'rangeSlider')
                  && (filter.type !== 'category' && lengthOfAggregate >= 6)
                  || (filter.type === 'category' && lengthOfAggregate >= 2)"
              >
                <input
                    type="text"
                    class="q-form-control filter-search__input"
                    :placeholder="SmartSearchTranslations.serp.filterSearchHeader"
                    v-model="searchQuery"
                />
              </li>

              <FilterCheckboxRecursive
                  v-if="filter.type === 'checkbox' || filter.type === 'category'"
                  :values="filteredValues"
                  :field="filter.field"
              />

              <BoxItem
                  v-if="filter.type === 'box'"
                  :filterDataValues="filteredValues"
                  :field="filter.field"
              />

              <InputRangeItem
                  v-if="filter.type === 'range'"
                  :filterData="filter.data"
                  :field="filter.field"
              />

              <MultiRangeSlider
                  v-if="filter.type === 'rangeSlider'"
                  :filterData="filter.data"
                  :field="filter.field"
              />
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {computed, defineProps, ref, inject} from 'vue'
import {SmartSearchTranslationsInterface} from '@/core/types'

// Podrzędne komponenty
import FilterCheckboxRecursive from './FilterItem/FilterCheckboxRecursive.vue'
import BoxItem from './FilterItem/BoxItem.vue'
import InputRangeItem from './FilterItem/InputRangeItem.vue'
import MultiRangeSlider from './FilterItem/MultiRangeSlider.vue'

// Props
const props = defineProps(['filter', 'filterCollapsed'])

const isCollapsed = ref(props.filterCollapsed || false)

function toggleAccordion() {
  isCollapsed.value = !isCollapsed.value
}

const lengthOfAggregate = computed(() => props?.filter?.data?.values?.length || 0)


// Tłumaczenia (jak w Twoim kodzie)
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!

// Klasy CSS do <ul>
const computedClass = computed(() => {
  if (props.filter.type === 'box') {
    return `q-p-0 serp__filter-item--${props.filter.type}`
  }
  return [
    'serp__filter-item--group',
    `serp__filter-item--${props.filter.type}`,
    'q-list-group',
    'q-list-group-flush',
    'q-list-group-collapse',
  ]
})

const computedClassContainer = computed(() => {
  return [`filter__item-container-${props.filter.type}`]
})

// SEARCH
const searchQuery = ref('')

// 1) Definiujemy rekurencyjną funkcję filtrującą
function filterCategoriesRecursive(values: any[], query: string) {
  // jeżeli brak query => nie filtrujemy
  if (!query) {
    return values
  }
  // w przeciwnym wypadku mapujemy i filtrujemy
  return values
      .map(item => {
        // Czy ten element pasuje w labelu?
        const match = item.label.toLowerCase().includes(query)
        // Czy istnieją podkategorie?
        let subItems = []
        if (item.aggregations && item.aggregations.length) {
          // Rekurencyjnie filtrujemy potomków
          subItems = filterCategoriesRecursive(item.aggregations, query)
        }

        // Zostawiamy ten element, jeśli:
        // a) Sam pasuje (match),
        // b) albo jego któryś potomek pasuje (subItems niepuste).
        if (match || subItems.length > 0) {
          // Zwracamy nowy obiekt z *przefiltrowaną* listą subItems
          return {
            ...item,
            aggregations: subItems,
          }
        } else {
          // W przeciwnym wypadku odrzucamy go (undefined)
          return undefined
        }
      })
      // wyrzucamy te, które są undefined
      .filter(Boolean)
}

function filterFlat(values: any[], query: string) {
  if (!query) {
    return values
  }
  return values.filter(item =>
      item.label.toLowerCase().includes(query)
  )
}

// 2) computed, które zwraca przefiltrowane dane
const filteredValues = computed(() => {
  // pobieramy oryginalną listę
  const allValues = props.filter.data.values || []

  // w zależności czy to kategorie (rekurencyjne), czy np. box
  // możemy przyjąć:
  if (props.filter.type === 'category' || props.filter.type === 'checkbox') {
    return filterCategoriesRecursive(allValues, searchQuery.value.toLowerCase())
  } else if (props.filter.type === 'box') {
    // Do "box" wystarczy płaska filtracja, np.:
    return filterFlat(allValues, searchQuery.value.toLowerCase())
  }
  // Inne typy (range, slider) - tu nie filtrujemy
  return allValues
})

</script>

<style>
/* Twój dotychczasowy CSS */
.dropdown-divider__container, .filter-search__container {
  grid-column: 1 / -1;
}

.serp__filter-item--container {
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}

.serp__filter-item--box {
  display: grid !important;
  grid-template-columns: repeat(3, 3fr);
  width: -moz-max-content !important;
  width: max-content !important;
  min-width: 100%;
}

.filter-item__box-text {
  font-size: 0.75rem !important;
}

.filter__item-container-rangeSlider {
  min-height: 80px;
}

.q-accordion-item {
  background-color: #fff;
  border: 0px solid rgba(0, 0, 0, .125);
}

.q-accordion-header {
  cursor: pointer;
}

.q-accordion-button.q-rotatable::after {
  flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
  margin-left: auto;
  content: "";
  background-image: url("data:image/svg+xml,%3csvg ...");
  background-repeat: no-repeat;
  background-size: 1.25rem;
  display: block;
  position: absolute;
  right: 1rem;
  bottom: 0.5rem;
}

.q-rotatable::after {
  transform: rotate(0deg);
  transition: transform .2s ease-in-out;
}

.q-rotated::after {
  transform: rotate(180deg);
}

.q-form-control.filter-search__input:focus {
  border-color: var(--q-red) !important;
}
</style>
